// Full copy for the "Invite a Friend" invitation card in all four languages
// the card artwork itself is available in. Each background image (see
// InviteFriend.jsx) is already localized — this only covers the page UI,
// the dynamic "Dear"/"With love" lines drawn on top of it, and status text.
const T = {
  en: {
    dear: "Dear",
    love: "With love,",
    ui: {
      eyebrow: "Elayone Music · Sunday 22 November",
      h1: "Invite a friend to None Urabikoze",
      lede: "Choose the invitation language, then fill in your friend’s name and your name. The invitation card updates instantly. Then download it or share it straight away.",
      langLabel: "Invitation language",
      friendLabel: "Your friend’s full names",
      friendHint: "Appears after “Dear” on the invitation card.",
      meLabel: "Your full names",
      meHint: "Appears after “With love,” on the invitation card.",
      download: "Download invitation",
      wa: "Share on WhatsApp",
      enterBoth: "Enter both names to download or share the invitation card.",
      saved: "Invitation card saved as",
      shared: "Shared.",
      shareFail: "Sharing did not work here. Use Download invitation instead.",
      facts: [
        ["When", "Sunday, 22 November 2026 · 3:00 PM"],
        ["Where", "Expo Ground, Gikondo, Kigali"],
        ["Entry", "Free"],
        ["Register", "Scan the QR code on the invitation card, or visit elayonemusic.org/register"],
      ],
      alt: "Your personal invitation card for the None Urabikoze Worship Concert",
    },
  },
  rw: {
    dear: "Mukundwa",
    love: "Mwene So,",
    ui: {
      eyebrow: "Elayone Music · Ku Cyumweru, 22 Ugushyingo",
      h1: "Tumira inshuti yawe mu gitaramo None Urabikoze",
      lede: "Hitamo ururimi rw’ikarita y’ubutumire, hanyuma wandike amazina y’inshuti yawe n’ayawe. Ikarita y’ubutumire yiyuzuza uko wandika. Hanyuma uyibike cyangwa uyoherereze inshuti yawe.",
      langLabel: "Ururimi rw’ikarita y’ubutumire",
      friendLabel: "Amazina y’inshuti yawe",
      friendHint: "Aza nyuma ya “Mukundwa” ku ikarita y’ubutumire.",
      meLabel: "Amazina yawe",
      meHint: "Aza nyuma ya “Mwene So,” ku ikarita y’ubutumire.",
      download: "Bika ikarita y’ubutumire",
      wa: "Sangiza kuri WhatsApp",
      enterBoth: "Andika amazina yombi kugira ngo ubike cyangwa usangize ikarita y’ubutumire.",
      saved: "Ikarita y’ubutumire yabitswe ku izina",
      shared: "Byoherejwe.",
      shareFail: "Kohereza ntibyakunze hano. Kanda “Bika ikarita y’ubutumire”.",
      facts: [
        ["Ryari", "Ku Cyumweru, 22 Ugushyingo 2026 · Saa cyenda z’amanywa"],
        ["Hehe", "Expo Ground, Gikondo, Kigali"],
        ["Kwinjira", "Ni ubuntu"],
        ["Kwiyandikisha", "Sikana QR code iri ku ikarita y’ubutumire, cyangwa usure elayonemusic.org/register"],
      ],
      alt: "Ikarita yawe y’ubutumire mu gitaramo None Urabikoze",
    },
  },
  fr: {
    dear: "Cher/Chère",
    love: "Affectueusement,",
    ui: {
      eyebrow: "Elayone Music · Dimanche 22 novembre",
      h1: "Invite un(e) ami(e) à None Urabikoze",
      lede: "Choisis la langue de l’invitation, puis saisis le nom de ton ami(e) et le tien. La carte d’invitation se met à jour instantanément. Ensuite, télécharge-la ou partage-la directement.",
      langLabel: "Langue de l’invitation",
      friendLabel: "Nom complet de ton ami(e)",
      friendHint: "S’affiche après « Cher/Chère » sur la carte d’invitation.",
      meLabel: "Ton nom complet",
      meHint: "S’affiche après « Affectueusement, » sur la carte d’invitation.",
      download: "Télécharger l’invitation",
      wa: "Partager sur WhatsApp",
      enterBoth: "Saisis les deux noms pour télécharger ou partager la carte d’invitation.",
      saved: "Carte d’invitation enregistrée sous",
      shared: "Partagée.",
      shareFail: "Le partage ne fonctionne pas ici. Utilise « Télécharger l’invitation ».",
      facts: [
        ["Quand", "Dimanche 22 novembre 2026 · 15 h 00"],
        ["Où", "Expo Ground, Gikondo, Kigali"],
        ["Entrée", "Gratuite"],
        ["Inscription", "Scanne le QR sur la carte d’invitation, ou visite elayonemusic.org/register"],
      ],
      alt: "Ta carte d’invitation personnelle au concert de louange None Urabikoze",
    },
  },
  sw: {
    dear: "Mpendwa",
    love: "Kwa upendo,",
    ui: {
      eyebrow: "Elayone Music · Jumapili, 22 Novemba",
      h1: "Mwalike rafiki yako kwenye None Urabikoze",
      lede: "Chagua lugha ya mwaliko, kisha andika jina la rafiki yako na lako. Kadi ya mwaliko inasasishwa papo hapo. Kisha ipakue au uishiriki moja kwa moja.",
      langLabel: "Lugha ya mwaliko",
      friendLabel: "Majina kamili ya rafiki yako",
      friendHint: "Yanaonekana baada ya “Mpendwa” kwenye kadi ya mwaliko.",
      meLabel: "Majina yako kamili",
      meHint: "Yanaonekana baada ya “Kwa upendo,” kwenye kadi ya mwaliko.",
      download: "Pakua mwaliko",
      wa: "Shiriki kwenye WhatsApp",
      enterBoth: "Andika majina yote mawili ili kupakua au kushiriki kadi ya mwaliko.",
      saved: "Kadi ya mwaliko imehifadhiwa kama",
      shared: "Imeshirikiwa.",
      shareFail: "Kushiriki hakujafanya kazi hapa. Tumia “Pakua mwaliko”.",
      facts: [
        ["Lini", "Jumapili, 22 Novemba 2026 · Saa 9 alasiri"],
        ["Wapi", "Expo Ground, Gikondo, Kigali"],
        ["Kiingilio", "Bure"],
        ["Usajili", "Skani QR kwenye kadi ya mwaliko, au tembelea elayonemusic.org/register"],
      ],
      alt: "Kadi yako ya mwaliko wa tamasha la kuabudu None Urabikoze",
    },
  },
};

export const LANGUAGES = [
  { code: "rw", label: "Kinyarwanda" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "sw", label: "Kiswahili" },
];

export default T;
